enum RouteName {
  Transactions = 'transactions',
  TokenPnl = 'token-pnl',
  Raffle = 'raffle',
  NftReward = 'nft-reward',
  Swap = 'swap',
  SwapWidget = 'swap-widget',
  Test = 'test',
}

export default RouteName;
